export default "__VITE_ASSET__D_S3D14s__"